import React, { useState } from "react";
import "./DappAccordion.css";

export default function DappAccordion() {
  const [openItems, setOpenItems] = useState([]);

  const accordionItems = [
    {
      id: 1,
      title: "Immutable Data Security",
      content: "Blockchain-based records are permanently stored and protected from tampering, ensuring application data remains accurate, verifiable, and secure over the long term."
    },
    {
      id: 2,
      title: "On-Chain Transparency",
      content: "Every transaction is recorded on the blockchain, allowing participants to verify activity in real time and maintain trust through complete traceability."
    },
    {
      id: 3,
      title: "Decentralized Control",
      content: "System operations are distributed across the network, removing dependence on central authorities and reducing the risk of single points of failure."
    },
    {
      id: 4,
      title: "Smart Contract Automation",
      content: "Predefined smart contract logic automates transactions and workflows, minimizing manual intervention while ensuring consistent and reliable execution."
    },
    {
      id: 5,
      title: "User Data Ownership",
      content: "Control over digital identities and assets stays with users, enabling greater privacy, autonomy, and protection against centralized data misuse."
    },
    {
      id: 6,
      title: "Web3 Scalability",
      content: "The underlying architecture is designed to scale efficiently as user activity, digital assets, and blockchain networks continue to expand."
    }
  ];

  const toggleItem = (id) => {
    if (openItems.includes(id)) {
      setOpenItems(openItems.filter(itemId => itemId !== id));
    } else {
      setOpenItems([...openItems, id]);
    }
  };

  return (
    <div id="dapp-accordion" className="dappmainclass">
      <div className="left">
        <h2>Why Our Approach Works</h2>
        <p>
          Our approach is designed to help businesses confidently adopt decentralized technology by combining strong security, transparent operations, and user ownership with architectures built for real-world Web3 growth.
        </p>
      </div>
      <div className="right">
        <div className="accordion">
          {accordionItems.map((item) => (
            <div key={item.id} className={`accordion-item ${openItems.includes(item.id) ? 'active' : ''}`}>
              <div className="accordion-header" onClick={() => toggleItem(item.id)}>
                <span>{item.title}</span>
                <span className="accordion-icon">{openItems.includes(item.id) ? '−' : '+'}</span>
              </div>
              {openItems.includes(item.id) && (
                <div className="accordion-content">
                  <p>{item.content}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}